import React from "react"
import { withPrefix, StaticQuery, graphql } from "gatsby"
import Image from "../components/image"

const File = (props) => {
  return (
    <StaticQuery
      query={graphql`
          query { 
            images: allFile {
              edges {
                node {
                  absolutePath
                  publicURL
                  name
                  ext
                }
              }
            }
          }
        `}
      render={(data) => {
        var file = data.images.edges.find(n => {
          return n.node.absolutePath.includes(props.src);
        });
        const iconFile = 'icon_file_' + file.node.ext.replace('.', '') + '.svg';
        return (
          <a className={'download-link'} href={withPrefix(file.node.publicURL)} target="_blank" rel="noopener onreferrer">
            <span className={'file'}><Image src={iconFile} className={'icon'} /><p>{file.node.name + file.node.ext}</p></span>
          </a>
        );
      }}
    />
  )
}

export default File
